import { UseQueryResult, useQuery } from 'react-query';

import { getTokenWithType } from './useAuth';

import { versionHistoryList } from '../utils/urls';

import { VersionListResult } from 'types/procedureBuilder';
import { ErrorModal } from 'types/modalTypes';

async function fetchVersionHistory({
  account,
  procedureId,
}: TVariables): Promise<TResult> {
  const response = await fetch(versionHistoryList(account, procedureId), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: VersionListResult;
  IsSuccess: boolean;
  StatusCode: number;
};

type TVariables = {
  account: number;
  procedureId: number | undefined;
};

function useGetVersionHistory(
  account: number,
  procedureId: number | undefined,
): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_procedure_version_history', account, procedureId],
    async () => {
      if (procedureId)
        return await fetchVersionHistory({
          procedureId,
          account,
        });
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: true,
    },
  );
}

export { useGetVersionHistory };
